module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("粉丝管理")])]), _vm._v(" "), _c('z-tab-bar', {
    attrs: {
      "list-obj": _vm.tabBarParams.list,
      "active": _vm.tabBarParams.active
    },
    on: {
      "handleClickTabBar": _vm.handleClickTabBar
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "min-width"
  }, [_c('z-search', {
    staticClass: "m-b-20",
    attrs: {
      "placeholder": "请输入昵称"
    },
    on: {
      "handleSearch": _vm.handleGetFansList
    },
    model: {
      value: (_vm.params.search),
      callback: function($$v) {
        _vm.$set(_vm.params, "search", $$v)
      },
      expression: "params.search"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-list"
  }, [_c('ul', _vm._l((_vm.list.list || []), function(item, index) {
    return _c('li', [_c('dl', {
      staticClass: "fx fx-y-center"
    }, [_c('dd', {
      staticClass: "fx fx-y-center"
    }, [_c('p', {
      staticClass: "pic-cont"
    }, [_c('img', {
      attrs: {
        "src": item.headimgurl || _vm.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-name text-ellipsis"
    }, [_vm._v(_vm._s(item.nickname || '-'))])]), _vm._v(" "), _c('dd', {
      staticClass: "text-center fx-fill"
    }, [_vm._v(_vm._s(item.openid))]), _vm._v(" "), _c('dd', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.subscribe ? '已关注' : '未关注'))]), _vm._v(" "), _c('dd', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.sex > 1 ? '女' : '男'))]), _vm._v(" "), _c('dd', {
      staticClass: "text-center"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.country),
        expression: "item.country"
      }]
    }, [_vm._v(_vm._s(item.country + item.province + item.city))])]), _vm._v(" "), _c('dd', {
      staticClass: "user-time text-right"
    }, [_vm._v(_vm._s(_vm._f("momentFmt")(item.subscribe_time)))])])])
  }), 0), _vm._v(" "), (_vm.list.list.length <= 0) ? _c('div', [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fx-y-center pages-cont"
  }, [_c('z-pages', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.list.item_total || 0
    },
    on: {
      "handleOffset": _vm.handleGetFansList
    }
  })], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "fx"
  }, [_c('p', {
    staticClass: "p-l-20"
  }, [_vm._v("用户")]), _vm._v(" "), _c('p', {
    staticClass: "text-center fx-fill"
  }, [_vm._v("openid")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("状态")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("性别")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("地区")]), _vm._v(" "), _c('p', {
    staticClass: "text-right p-r-20"
  }, [_vm._v("关注时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx-align"
  }, [_c('p', {
    staticClass: "p-20"
  }, [_vm._v("暂无记录 (˘•ω•˘)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6c7c3dee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxMemberList.vue
// module id = 863
// module chunks = 0